import type { AxiosError } from "axios";
import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { appVectorToolsApi } from "../../config/apiConfig";
import type { Model, PostObjType, Vectors } from "./types";

export const getModels = (): Promise<Model[]> => {
  return appVectorToolsApi
    .get("/get_models", {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getVectors = (postObj: PostObjType): Promise<Vectors> => {
  return appVectorToolsApi
    .post("/get_vectors", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
